import { useState } from 'react'

const SpotifyApp = () => {
  const [currentPlaylist, setCurrentPlaylist] = useState('0u7cyBXvFT1aU0Y93zSjdX') // Default: Pink Pixel 💖
  const [isLoading, setIsLoading] = useState(true)

  // Featured playlists with their Spotify IDs
  const featuredPlaylists = [
    {
      id: '0u7cyBXvFT1aU0Y93zSjdX',
	  name: 'Pink Pixel:Dream It, Pixel It',
      description: "Handpicked tracks by Pink Pixel",
      genre: 'Curated Mix',
      isPinkPixel: true
    },
    {
      id: '0BSd21ywKvjn4iNvPcFzXK',
      name: 'CLOUDWERX.DEV:Digital Food for the Analog Soul',
      description: "Tracks handpicked by Pink Pixel's hubby, CLOUDWERXLAB.",
      genre: 'Curated Mix'
    },
    {
      id: '2tXr2Zychw0npRUeIHLQLZ',
      name: 'Pink Pixel & Cloudwerx Collection',
      description: "A little bit random but a lot of awesome.",
      genre: 'Curated Mix'
    },
	{
      id: '4oU5qZki4e9Tzec7Gq3MKz',
      name: 'Pink Pixel: Pixelated Happiness',
      description: "More Handpicked tracks by Pink Pixel",
      genre: 'Curated Mix',
      isPinkPixel: true
    },
    {
      id: '37i9dQZF1EQqZlCxLOykhS',
      name: '80s Mix',
      description: "The 80's Were Pretty Damn Great Sometimes",
      genre: 'Punk/Post-Punk/New Wave'
    },
    {
      id: '2uDVS1t0HqMnczrWgA1xcJ',
      name: 'Lo-Fi Hip Hop',
      description: "The perfect beats for studying or relaxtion.",
      genre: 'Lo-Fi'
    },
    {
      id: '37i9dQZF1DWWEJlAGA9gs0',
      name: 'Classical Essentials',
      description: "The greatest classical masterpieces of all time.",
      genre: 'Classical'
    }
  ]

  const handlePlaylistChange = (playlistId) => {
    setIsLoading(true)
    setCurrentPlaylist(playlistId)
    // Simulate loading delay for better UX
    setTimeout(() => setIsLoading(false), 1000)
  }

  const handleIframeLoad = () => {
    setIsLoading(false)
  }

  const currentPlaylistInfo = featuredPlaylists.find(p => p.id === currentPlaylist)

  return (
    <div className="h-full flex flex-col bg-gradient-to-br from-green-900/20 to-black/40 text-white">
      {/* App Header */}
      <div className="flex items-center justify-between p-4 bg-green-600/20 backdrop-blur-sm border-b border-green-400/30">
        <div className="flex items-center space-x-3">
          <i className="fab fa-spotify text-green-400 text-2xl"></i>
          <div>
            <h2 className="text-lg font-semibold">Spotify</h2>
            <p className="text-sm text-gray-300">Music for everyone</p>
          </div>
        </div>
        
        <div className="flex items-center space-x-2">
          <div className="flex items-center space-x-1 text-sm text-green-300">
            <i className="fas fa-music text-xs"></i>
            <span>Now Playing: {currentPlaylistInfo?.name}</span>
          </div>
        </div>
      </div>

      <div className="flex-1 flex overflow-hidden">
        {/* Sidebar - Playlist Selection */}
        <div className="w-80 bg-black/30 backdrop-blur-sm border-r border-green-400/20 p-4 overflow-y-auto">
          <h3 className="text-green-300 font-semibold mb-4 flex items-center">
            <i className="fas fa-list-ul mr-2"></i>
            Featured Playlists
          </h3>
          
          <div className="space-y-2">
            {featuredPlaylists.map((playlist) => (
              <div
                key={playlist.id}
                onClick={() => handlePlaylistChange(playlist.id)}
                className={`p-3 rounded-lg cursor-pointer transition-all duration-200 ${
                  playlist.isPinkPixel
                    ? currentPlaylist === playlist.id
                      ? 'bg-gradient-to-r from-pink-500/30 to-green-500/30 ring-1 ring-pink-400/50'
                      : 'bg-gradient-to-r from-pink-500/10 to-green-500/10 hover:from-pink-500/20 hover:to-green-500/20 border border-pink-400/20'
                    : currentPlaylist === playlist.id
                      ? 'bg-green-500/30 ring-1 ring-green-400/50'
                      : 'hover:bg-white/10'
                }`}
              >
                <div className="flex items-start justify-between">
                  <div className="flex-1 min-w-0">
                    <p className="font-medium text-white truncate">{playlist.name}</p>
                    <p className="text-sm text-gray-400 line-clamp-2">{playlist.description}</p>
                    <span className={`inline-block mt-1 px-2 py-1 text-xs rounded-full ${
                      playlist.isPinkPixel 
                        ? 'bg-gradient-to-r from-pink-500/30 to-purple-500/30 text-pink-300 border border-pink-400/20'
                        : 'bg-green-600/30 text-green-300'
                    }`}>
                      {playlist.isPinkPixel && '✨ '}{playlist.genre}
                    </span>
                  </div>
                  {currentPlaylist === playlist.id && (
                    <i className="fas fa-play text-green-400 text-sm ml-2 flex-shrink-0"></i>
                  )}
                </div>
              </div>
            ))}
          </div>

          {/* Pink Pixel Branding */}
          <div className="mt-8 p-3 bg-pink-500/10 rounded-lg border border-pink-400/20">
            <div className="flex items-center space-x-2">
              <i className="fas fa-star text-pink-400"></i>
              <span className="text-sm text-pink-300">Curated by Pink Pixel</span>
            </div>
            <p className="text-xs text-gray-400 mt-1">
              Handpicked playlists for coding, creating, and just doing your own weird thing.
            </p>
          </div>
        </div>

        {/* Main Content - Spotify Widget */}
        <div className="flex-1 flex flex-col">
          {/* Current Playlist Info */}
          <div className="p-4 bg-green-500/10 border-b border-green-400/20">
            <h3 className="text-xl font-semibold text-green-300">{currentPlaylistInfo?.name}</h3>
            <p className="text-gray-300 text-sm">{currentPlaylistInfo?.description}</p>
            <div className="flex items-center space-x-4 mt-2 text-sm text-gray-400">
              <span><i className="fas fa-tag mr-1"></i>{currentPlaylistInfo?.genre}</span>
              <span><i className="fab fa-spotify mr-1"></i>Spotify Official</span>
            </div>
          </div>

          {/* Spotify Embed */}
          <div className="flex-1 p-4 relative">
            {isLoading && (
              <div className="absolute inset-4 flex items-center justify-center bg-black/20 backdrop-blur-sm rounded-lg z-10">
                <div className="text-center">
                  <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-green-400 mb-3"></div>
                  <p className="text-green-300">Loading playlist...</p>
                </div>
              </div>
            )}
            
            <iframe
              src={`https://open.spotify.com/embed/playlist/${currentPlaylist}?utm_source=generator&theme=0`}
              width="100%"
              height="100%"
              frameBorder="0"
              allowFullScreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
              onLoad={handleIframeLoad}
              className="rounded-lg bg-black/50"
              title="Spotify Playlist"
            ></iframe>
          </div>

          {/* Footer Info */}
          <div className="p-3 bg-black/20 border-t border-green-400/20 text-center">
            <p className="text-xs text-gray-400">
              <i className="fab fa-spotify text-green-400 mr-1"></i>
              Powered by Spotify. Premium account may be required for full playback.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SpotifyApp
